import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

var _dec, _class;

import { AssignmentSummary, ConfigType, AssignmentDisplayStatusV2, UnixTimestamp } from '../../core';
import { BadInputError, Result } from '@digibricks/domains';
import { Injectable } from '@nestjs/common';
export var AssignmentSummaryWebMapper = (_dec = Injectable(), _dec(_class = /*#__PURE__*/function () {
  function AssignmentSummaryWebMapper() {
    _classCallCheck(this, AssignmentSummaryWebMapper);
  }

  _createClass(AssignmentSummaryWebMapper, [{
    key: "toDomain",
    value: function toDomain(dto) {
      var id = dto.id,
          title = dto.title,
          idNumber = dto.idNumber,
          formId = dto.formId,
          type = dto.type,
          systemStatus = dto.systemStatus,
          duration = dto.duration,
          startTime = dto.startTime,
          endTime = dto.endTime,
          totalAttendee = dto.totalAttendee,
          createdAt = dto.createdAt,
          hasPassword = dto.hasPassword,
          scoreVisibilityType = dto.scoreVisibilityType,
          hasPublishedScoreInformation = dto.hasPublishedScoreInformation;
      var typeOrError = ConfigType.create({
        id: type.id,
        name: type.name
      });

      if (typeOrError.isFailure) {
        return Result.fail(typeOrError.error);
      }

      var systemStatusOrError = ConfigType.create({
        id: systemStatus.id,
        name: systemStatus.name
      });

      if (systemStatusOrError.isFailure) {
        return Result.fail(systemStatusOrError.error);
      }

      var displayStatus = AssignmentDisplayStatusV2.getDisplayStatusForExamination(UnixTimestamp.now(), startTime, endTime, scoreVisibilityType, hasPublishedScoreInformation);
      var durationMinutes = duration != null && !Number.isNaN(Number(duration)) ? Number(duration) : undefined;
      var props = {
        id: id,
        title: title,
        idNumber: idNumber,
        formId: formId,
        type: typeOrError.getValue(),
        systemStatus: systemStatusOrError.getValue(),
        displayStatus: displayStatus,
        startTime: startTime,
        endTime: endTime,
        totalAttendee: totalAttendee,
        createdAt: createdAt,
        hasPassword: hasPassword,
        duration: durationMinutes
      };
      var assignmentSummaryOrError = AssignmentSummary.create(props);

      if (assignmentSummaryOrError.isFailure) {
        return new BadInputError(assignmentSummaryOrError.error);
      }

      return assignmentSummaryOrError;
    }
  }]);

  return AssignmentSummaryWebMapper;
}()) || _class);